/**
 * 三包理赔的修改页面的配置处理
 * @author zjs
 * @time 2017-09-18
 */
export default {
    data () {
        return {
            // 表单组件配置
            formConfig: [{
                name: "开单日期",
                type: "LyDatePicker",
                field: "work_time",
                json: {
                    type: 'date',
                    disabled: true
                },
                default: ""
            },{
                name: "收胎/受理日期",
                type: "LyDatePicker",
                field: "lipei_time",
                json: {
                    type: 'date'
                },
                default: ""
            }, {
                name: "理赔单单号",
                type: "ElInput",
                field: "lp_no",
                json: {
                    disabled: true
                },
                default: ""
            },{
                name: "客户名称",
                type: "LyAutoSearch",
                field: "customer",
                width: '220px',
                json: {
                    width: '661px',
                    api: 'api/customer',
                    prop: 'customer_name',
                    fields: [{
                        label: '客户编码',
                        prop: 'customer_account',
                        width: 90
                    }, {
                        label: '客户名称',
                        prop: 'customer_name',
                        width: 270
                    }, {
                        label: '联系人',
                        prop: 'customer_contact',
                        width: 160
                    }, {
                        label: '联系电话',
                        prop: 'customer_tel',
                        width: 140
                    }]
                },
                default: {}
            },{
                name: "联系人",
                type: "LyAutoSearch",
                field: "customer",
                width: '220px',
                json: {
                    width: '661px',
                    api: 'api/customer',
                    prop: 'customer_contact',
                    fields: [{
                        label: '客户编码',
                        prop: 'customer_account',
                        width: 90
                    }, {
                        label: '客户名称',
                        prop: 'customer_name',
                        width: 270
                    }, {
                        label: '联系人',
                        prop: 'customer_contact',
                        width: 160
                    }, {
                        label: '联系电话',
                        prop: 'customer_tel',
                        width: 140
                    }]
                },
                default: {
                }
            },{
                name: "收胎票据号",
                type: "ElInput",
                field: "piaoju_no",
                json: {},
                default: ""
            },{
                name: "联系地址",
                type: "ElInput",
                field: "customer",
                json: {
                    prop: 'customer_address'
                },
                default: ""
            },{
                name: "联系电话",
                type: "ElInput",
                field: "customer",
                json: {
                    prop: 'customer_tel'
                },
                default: ""
            },{
                name: "送单人",
                type: "ElInput",
                field: "sender",
                json: {},
                default: ""
            }, {
                name: "经营团队",
                type: "LySelect",
                field: "jingying_id",
                json: { 
                    all: false,
                    api: 'api/jingyingtd'
                },
                default: ""
            }, {
                name: "制单人",
                type: "ElInput",
                field: "zhidan_name",
                json: {
                    disabled: true
                },
                default: ""
            }, {
                name: "批次",
                type: "LyBatch",
                field: "pici",
                json: {},
                default: ""
            }, {
                name: "引用登记单号",
                type: "ElInput",
                field: "guanlian_transaction_no",
                json: {},
                default: ""
            }, {
                name: "理赔方式",
                type: "LySelect",
                field: "lipei_manner",
                json: {
                    all: false,
                    data: [{
                        value: '1',
                        label: '赔胎'
                    }, {
                        value: '2',
                        label: '赔钱'
                    }, {
                        value: '3',
                        label: '不理赔'
                    }]
                },
                default: ""
            }, {
                name: "摘要",
                type: "ElInput",
                field: "zhaiyao",
                width: '1005px',
                json: {
                    span: 24
                },
                default: ""
            }],
            // 对应表单中的字段验证规则
            formRules: {},
        }
    }
}